<template>
    <v-app>
        <v-content>
            <v-container id="main-content" fluid fill-height>
                <v-layout justify-center align-center>
                    <main role="main" class="container">
                        <router-view></router-view>
                    </main>
                </v-layout>
            </v-container>
        </v-content>
    </v-app>
</template>

<script>
    import Footer from './Footer';

    export default {
        data: () => ({
            dialog: false,
            logo_icon: require('@/assets/logo.png'),
            drawer: '',
            loading: true
        }),
        components: {
            Footer
        },
        beforeMount() {
            this.navDrawerMobile();
        },
        mounted() {

        },
        methods: {
            navDrawerMobile() {
                if (window.innerWidth < 1264) {
                    this.drawer = false;
                } else {
                    this.drawer = true;
                }
            },
        }
    }
</script>

<style scoped>
    /* Old Vuetify version  */
    .navigation-drawer > .list:not(.list--dense) .list__tile {
        font-size: 13px;
        text-decoration: none;
    }

    .navDrawer > .v-list:not(.v-list--dense) .v-list__tile {
        font-size: 13px;
        text-decoration: none;
    }

    /* Old Vuetify version  */
    .navDrawer .subGroupOne .list__group__header--sub-group {
        padding-left: 25px;
    }

    .navDrawer .subGroupOne .v-list__group__header--sub-group {
        padding-left: 25px;
    }

    /* Old Vuetify version  */
    .navDrawer .list__group__items--no-action .list__tile {
        padding-left: 110px;
    }

    .navDrawer .v-list__group__items--no-action .v-list__tile {
        padding-left: 110px;
    }

    .application .theme--light.list, .theme--light .list {
        color: grey;
    }

    /**Navigation Bar Style **/

    .list--dense {
        padding-top: 17px;
    }

    .subheader {
        padding-left: 0px;
    }

    .list__tile__title.sub-text-deactive {
        padding-left: 50px;
        color: grey;
    }

    .list__tile__title.heading-active {
        padding-left: 0px;
    }

    /*Align buttons hover*/
    .toolbar__side-icon.btn.btn--icon {
        margin: -6px;
    }

    .toolbar-icons .btn__content {
        margin: 0px !important;
    }

    /*Progress bar*/
    .progress-linear {
        position: absolute;
        margin-top: 35px;
    }
    /*Logo*/
    #logo-portal{
        max-width: 115px;
        margin-left: 10px;
    }
</style>
